<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { useApp } from '@/composables/useApp';
  import { useAppStore } from '@/stores/app-store';

  const { loaded } = await useApp();

  const appStore = useAppStore();
  const { isFading } = storeToRefs(appStore);
</script>

<template>
  <div class="max-w-[1920px] mx-auto h-full">
    <transition name="fade">
      <div
        v-if="!loaded"
        class="site-loader" />
    </transition>
    <transition name="fade">
      <div
        v-if="isFading"
        class="page-fader" />
    </transition>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style>
  .page-enter-active,
  .page-leave-active {
    transition: all 0.3s;
  }

  .page-enter-from,
  .page-leave-to {
    opacity: 0;
  }
</style>
